const config = {
    API_BASE_URL: "https://qhlightingpakistan.com/backend/public"
  };
  
  export default config;